<template>
  <div class="w-full">
    <label class="text-xs text-gray-700" for="upload-files">Dateien zum hochladen</label>
    <table class="w-full -ml-1">
      <tr
        v-for="(file, index) in files"
        :key="index.toString() + file.name"
        class="text-muted"
      >
        <td
          style="max-width: 200px;"
          class="align-top truncate py-1 px-1"
        >
          <ElInput
            id="upload-files"
            :disabled="disableImageInputs && isSupportedImage(file)"
            :model-value="fileNames[index]"
            @update:model-value="value => emit('setFileName', value, index)"
          >
            <template #prepend>
              {{ index + 1 }}
            </template>
          </ElInput>
        </td>
        <td
          v-if="!disableImageInputs && isSupportedImage(file)"
          class="content-center"
          style="width: 5%"
        >
          <ElCheckbox
            :model-value="convertToPdfFlags[index]"
            @update:model-value="value => setConvertToPdf(index, value as boolean)"
          >
            <ElTooltip content="Bild als pdf speichern" placement="top">
              <FaIcon name="file-pdf" size="lg" variant="light" />
            </ElTooltip>
          </ElCheckbox>
        </td>
        <td
          class="content-center"
          style="width: 5%"
        >
          <a
            class="px-2.5 py-1.5 rounded-sm hover:bg-gray-100"
            href="#"
            @click.prevent.stop="emit('remove', index)"
          >
            <FaIcon
              name="trash"
              variant="light"
              size="lg"
              title="Datei entfernen"
              class="text-red-500"
            />
          </a>
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">
import FaIcon from '@/application/components/ui/FaIcon.vue';
import { ElCheckbox, ElInput, ElTooltip } from 'element-plus';
import { isSupportedImage } from '@/documents/composables/documentUpload.ts';

interface Props {
  files: File[],
  fileNames: string[],
  disableImageInputs: boolean,
  convertToPdfFlags: boolean[],
}

defineProps<Props>();

const emit = defineEmits<{
  remove: [index: number]
  setFileName: [value: string, index: number]
  setConvertToPdf: [index: number, value: boolean]
}>();

const setConvertToPdf = (index: number, value: boolean) => {
  emit('setConvertToPdf', index, value);
};
</script>
